"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
var Logger = /** @class */ (function () {
    function Logger() {
    }
    Logger.log = function (level, message) {
        // TODO: how should errors be shown https://tfs.tsi.lan/tfs/DefaultCollection/Tableau-Dev/_workitems?id=849134
        if (level > Logger.LOGLEVEL) {
            return;
        }
        var levelStr = '';
        switch (level) {
            case 3:
                levelStr = 'ERROR';
                break;
            case 4:
                levelStr = 'WARN';
                break;
            case 5:
                levelStr = 'INFO';
                break;
            default:
                levelStr = 'DEBUG';
        }
        // tslint:disable-next-line:no-console
        console.log(levelStr + " : " + message);
    };
    Logger.error = function (message) {
        this.log(Logger.LEVEL.error, message);
    };
    Logger.warn = function (message) {
        this.log(Logger.LEVEL.warn, message);
    };
    Logger.info = function (message) {
        this.log(Logger.LEVEL.info, message);
    };
    Logger.debug = function (message) {
        this.log(Logger.LEVEL.debug, message);
    };
    Logger.LEVEL = {
        error: 3,
        warn: 4,
        info: 5,
        debug: 6
    };
    Logger.LOGLEVEL = Logger.LEVEL.warn;
    return Logger;
}());
exports.Logger = Logger;
//# sourceMappingURL=Logger.js.map